import { render, staticRenderFns } from "./NewMachine.vue?vue&type=template&id=b37639a8"
import script from "./NewMachine.vue?vue&type=script&lang=js"
export * from "./NewMachine.vue?vue&type=script&lang=js"
import style0 from "./NewMachine.vue?vue&type=style&index=0&id=b37639a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports